const contributors = document.querySelectorAll('.js-contributors-tooltip');
const keys = {
  // left: 37, up: 38, right: 39, down: 40,
  // spacebar: 32, pageup: 33, pagedown: 34, end: 35, home: 36
  37: 1, 38: 1, 39: 1, 40: 1, 32: 1, 33: 1, 34: 1, 35: 1, 36: 1,
};

function preventDefault(e) {
  e.preventDefault();
}

function preventDefaultForScrollKeys(e) {
  if (keys[e.keyCode]) {
    preventDefault(e);
    return false;
  }
}

// modern Chrome requires { passive: false } when adding event
let supportsPassive = false;
try {
  window.addEventListener('test', null, Object.defineProperty({}, 'passive', {
    get() { supportsPassive = true; }
  }));
} catch (e) {}

const wheelOpt = supportsPassive ? { passive: false } : false;
const wheelEvent = 'onwheel' in document.createElement('div') ? 'wheel' : 'mousewheel';

const openModal = (contributor) => {
  if (window.innerWidth >= 768) {
    return true;
  }

  window.addEventListener(wheelEvent, preventDefault, wheelOpt); // modern desktop
  window.addEventListener('keydown', preventDefaultForScrollKeys, false);

  contributor.classList.add('active');
};

const closeModal = (contributor) => {
  if (window.innerWidth >= 768) {
    return true;
  }

  window.removeEventListener(wheelEvent, preventDefault, wheelOpt);
  window.removeEventListener('keydown', preventDefaultForScrollKeys, false);

  contributor.classList.remove('active');
};

contributors.forEach((contributor) => {
  const openContributor = contributor.querySelector('.js-contributors-tooltip-button');
  const closeContributor = contributor.querySelector('.js-contributors-tooltip-close');

  openContributor.addEventListener('click', () => {
    openModal(contributor);
  });
  closeContributor.addEventListener('click', () => {
    closeModal(contributor);
  });
});
